import script from "./ListOutsideBooks.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListOutsideBooks.vue?vue&type=script&lang=ts&setup=true"

export default script